import { useEffect, useRef, useState } from 'react'
import { useClickOutside } from '../../../../../../components/Hooks/useClickOutside'

const normalizeDetails = (rawDetails) => {
  const defaultDetails = {
    data: [{ id: 1, name: 'tom', surname: 'harry' }],
    options: {
      reRefKey: 'id',
      template: [{
        refKey: 'name',
        descr: '',
      }]
    }
  }

  const safeDetails = rawDetails || defaultDetails
  const data = Array.isArray(safeDetails.data) ? safeDetails.data : []
  const configuredKey = safeDetails.options?.reRefKey
  const detectedKey = data.some(item => item && item.id !== undefined && item.id !== null)
    ? 'id'
    : data.some(item => item && item.facility !== undefined && item.facility !== null)
      ? 'facility'
      : 'id'

  const reRefKey = configuredKey && data.some(item => item && item[configuredKey] !== undefined && item[configuredKey] !== null)
    ? configuredKey
    : detectedKey

  const template = Array.isArray(safeDetails.options?.template) && safeDetails.options.template.length > 0
    ? safeDetails.options.template
    : [{ refKey: reRefKey, descr: '' }]

  return { data, options: { ...(safeDetails.options || {}), reRefKey, template } }
}

export default function QBuilderSearch({ details, onsBeforeSearch, onAfterSearch, onSelected, placeholder, response, defaultValue }) {
  const mainRef = useRef()
  const searchRef = useRef()
  const resultsRef = useRef()
  const [isOpen, setIsOpen] = useState(false)
  const [results, setResults] = useState([])
  const [result, setResult] = useState([])
  const [options, setOptions] = useState(() => normalizeDetails(details))

  useClickOutside(mainRef, () => { setIsOpen(false) })

  useEffect(() => {
    setOptions(normalizeDetails(details))
  }, [details])

  useEffect(() => {
    setResults(options.data)
  }, [options])

  useEffect(() => {
    if (options.data && defaultValue !== undefined && defaultValue !== null && defaultValue !== '') {
      const normalizedDefaultValue = options.options.reRefKey === 'id' && typeof defaultValue === 'string' && defaultValue.trim() !== ''
        ? Number(defaultValue)
        : defaultValue

      const res = options.data.find(item => String(item[options.options.reRefKey]) === String(normalizedDefaultValue))
        || options.data.find(item => String(item[options.options.template?.[0]?.refKey]) === String(defaultValue))

      if (res) {
        setResult(res)
        if (resultsRef.current) {
          resultsRef.current.value = options.options.template
            .map((t) => `${res[t.refKey] ?? ''} `)
            .join('')
        }
      }
    }
  }, [defaultValue, options])

  /*
    Handle Events
  */

  const _handleSearch = (search) => {
    if (!search || search.trim() === '') {
      setResults(options.data)
      return;
    }
    const searchLower = search.toLowerCase();
    // Use a Set to avoid duplicates
    const resSet = new Set();
    for (const item of options.data) {
      for (const k of Object.keys(item)) {
        try {
          const value = String(item[k]).toLowerCase();
          if (value.includes(searchLower)) {
            resSet.add(item)
          }
        } catch (e) { }
      }
    }
    setResults(Array.from(resSet));
  }

  // Toggle component open/close
  const _handleResultsClick = () => {
    setIsOpen(!isOpen)
    resultsRef.current.blur()
  }

  // Handle selected
  const _handleSetSelected = (res_id, result) => {
    setResult(result)
    if (onSelected) onSelected(res_id)
    if (resultsRef.current) {
      resultsRef.current.value = options.options.template
        .map((t) => `${result[t.refKey] ?? ''} `)
        .join('')
    }
    setIsOpen(false)
  }
  /*
    Render line item
  */

  const _renderResultItem = (r) => {
    if (!r || typeof r !== 'object') return null

    const lookupKey = options.options?.reRefKey || 'id'
    const res_id = r[lookupKey]
    const template = Array.isArray(options.options?.template) && options.options.template.length > 0
      ? options.options.template
      : [{ refKey: lookupKey, descr: '' }]

    if (res_id === undefined || res_id === null || res_id === '') {
      return null
    }

    const _node_value = template.map((t, i) => (
      <span key={`${lookupKey}-${res_id}-${t.refKey}-${i}`}>
        {t.descr ? <b>{t.descr}</b> : <></>} {r[t.refKey] ?? ''}
      </span>
    ))

    return <li key={`${lookupKey}-${res_id}`} className='m-1 p-1' onClick={() => _handleSetSelected(res_id, r)} >{_node_value}</li >
  }


  return (
    <div ref={mainRef} className='position-relative' style={{ height: 'inherit' }}>
      <input style={{ cursor: 'pointer' }} onClick={() => _handleResultsClick()} ref={resultsRef} className='form-control' placeholder={placeholder ? placeholder : ''} />
      <div className={'position-absolute p-3 bg-primary-container rounded shadow w-100 '.concat(isOpen ? 'd-block' : 'd-none')} style={{ zIndex: 999 }}>
        <input ref={searchRef} onChange={(e) => _handleSearch(e.target.value)} className='form-control' placeholder='Search' />
        <ul className='list-unstyled' style={{ maxHeight: '250px', overflow: 'auto', cursor: 'pointer' }}>
          {results.map((res) => _renderResultItem(res))}
        </ul>
      </div>
    </div>
  )
}
